import { fetcher } from '@commenda/utils';
import { TVendorServicePricingVariantDetails } from './vendors/types';

export async function getMarketplaceServicePricingVariantsForGuest({
  productId,
  country,
}: {
  productId: string;
  country: string;
}): Promise<{ data: TVendorServicePricingVariantDetails } | null> {
  const queryParams = new URLSearchParams();
  queryParams.set('productId', productId);
  queryParams.set('country', country);

  try {
    const res = await fetcher(
      `marketplace/guest-checkout/products?${queryParams.toString()}`,
      {
        method: 'GET',
      }
    );

    if (!res.ok) {
      return null;
    }

    const data: TVendorServicePricingVariantDetails =
      (await res.json()) as TVendorServicePricingVariantDetails;

    return { data };
  } catch (err) {
    console.error(err);
    return null;
  }
}
